import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled, { ThemeProvider } from "styled-components";
import '../utils/fontface.css';

import { useBoundStore } from "../stores/useBoundStore";

import GlobalStyle from "../components/atoms/GlobalStyles";
import Header from "../components/molecules/Header";

import { fontFamilies } from "../utils/fontFamilies";

import "../styles/root.css";
import {colorSchemeThemes} from "../utils/styling";

const Main = styled.main`
  position: relative;
  z-index: 1;

  min-height: 100vh;

  color: ${(props) => props.isHome ? `var(--white)` : props.theme.colors.color1};
  background-color: ${(props) => !props.isHome ? `var(--white)` : props.theme.colors.color1};
`;

const Root = () => {
  const colorScheme = useBoundStore((state) => state.colorScheme);
  const location = useLocation();

  return (
    <ThemeProvider theme={colorSchemeThemes[colorScheme]}>
      <GlobalStyle />
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />

        <link
          href={`https://fonts.googleapis.com/css2?${fontFamilies
            .map((family) => `family=${family.replace(` `, `+`)}&`)
            .join(``)}display=swap`}
          rel="stylesheet"
        />
      </Helmet>
      <Header isHome={location.pathname === "/"} />
      <Main isHome={location.pathname === "/"}>
        <Outlet />
      </Main>
    </ThemeProvider>
  );
};

export default Root;
